export enum ModeAction {
  SETUP = 'SETUP',
  CHANGE = 'CHANGE',
}
